import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {saveLocation} from '../../actions/locationActions';
import { Button, Progress} from 'reactstrap';
import Select from 'react-select';
import {toastr} from 'react-redux-toastr';
import {apiRequest, apiPost} from '../../utils/request';
import AddressesView from '../Addresses/AddressesView';
import CommunicationsView from '../Communications/CommunicationsView';
import ContactsView from '../Contacts/ContactsView';
import ContractsView from '../Contracts/ContractsView';
import moment from 'moment';
import TextBoxControl from '../Common/TextBoxControl';
import CheckBoxControl from '../Common/CheckBoxControl';
import TextAreaControl from '../Common/TextAreaControl';
import AttachmentsView from '../Attachments/AttachmentsView';
import NotesView from '../Notes/NotesView';
import RunModal from '../Runs/RunModal';
import UsersByClientLocationControl from '../Users/UsersByClientLocationControl';
import {
  allowUserWithRoles,
  Aux,
  BASE_URL,
  CUSTOMER_TYPES_IDS,
  CUSTOMER_TYPES_NAMES,
  GetIsBulkCustomerType, GetIsCollectionCustomer, GetIsFreshOilCustomer,
  IsCurrentUser,
  IsInRole,
  isNullEmptyOrWhitespace,
  IsNullOrUndefined,
  LOCATION_TYPE_BASE_CODE,
  LOCATION_TYPE_DROPOFF_CODE,
  ROLE_Admin,
  ROLE_ClientUser,
  ROLE_LocationUser,
  ROLE_OfficeUser,
  ROLE_SalesManager,
  ROLE_SuperUser,
  SHORT_DATE_FORMAT
} from "../../constants";
import {Link} from 'react-router-dom';
import {NewAddress} from "../Addresses/AddressView";
import ExistingClientLocaion from "../Common/ExistingClientLocation";
import ClosedPeriodsView from "./ClosedPeriodsView";
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import LocationTanksView from "./LocationTanksView";
import AttachmentView from "../Attachments/AttachmentView";
import { mustBeArray, trimWhiteSpaces } from '../../utils/lib';
import {unLinkMyob} from '../../actions/clientActions';
import { withRouter } from '../../utils/withRouter';
import { isValidAbn, isValidAccountName } from '../../utils/validations';
import LocationUsage from './subcomponents/LocationUsage.jsx';
import ClientHomeActionButtons from "../home/ClientHomeActionButtons";
import {listClientLocations} from "../../actions/homeActions";
import { Badge } from "reactstrap";
import {getRunFlag} from "../../utils/collectionTypes";

export const NewLocation = (selectedClient = null) => {
  return {
    id: -1,
    locationName: '',
    isInactive: false,
    businessDevelopmentManagerId: null,
    abn: '',
    addresses: [
      {...NewAddress(0), addressType: 'Location', isPrimary: true},
    ],
    assignedCustomerTypes: [],
    communications: [],
    contacts: [],
    driverNotes: '',
    driverDeliveryNotes: '',
    nextDeliveryPickupNote: '',
    notes: [],
    officeNotes: [],
    officeAttachments: [],
    deliveryAttachments: [],
    attachments: [],
    isGst: false,
    setupComplete: false,
    completedBy: null,
    locationStatusUniqueCode: 'A',
    clientId: selectedClient == null ? null : selectedClient.id,
    clientCompanyName: selectedClient == null ? null : selectedClient.companyName,
    runs: [],
    locationTinTankType: '',
    setDeliveryDays: [],
  };
};

const DaysOfWeek = [{
  value: 1,
  label: "Sunday",
},{
  value: 2,
  label: "Monday",
},{
  value: 3,
  label: "Tuesday",
},{
  value: 4,
  label: "Wednesday",
},{
  value: 5,
  label: "Thursday",
},{
  value: 6,
  label: "Friday",
},{
  value: 7,
  label: "Saturday",
}
];

class EditLocationView extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      originalLocation: null,
      location: null,
      runs: [],
      locationStatuses: [
        {value: 'A', label: 'Active'},
        {value: 'LJ', label: 'Lost Job'},
        {value: 'CD', label: 'Closed Down'},
      ],
      locationTypes: [
        {value: 'P', label: 'Client'},
        {value: 'B', label: 'Base'},
        {value: 'D', label: 'Drop-off'},
      ],
      customerTypes: [],
      selectedClient: props.clientId ? {id: props.clientId} : null,      
      viewRunId: -1,
      viewLocationId: -1,
      locationUsage: [],
      message: '',
      showLocationsWithNotes: false
    };

    this.handleSaveLocation = this.handleSaveLocation.bind(this);
    this.handleLocationFieldChange = this.handleLocationFieldChange.bind(this);
    this.validateLocation = this.validateLocation.bind(this);
    this.fetchClients = this.fetchClients.bind(this);
    this.handleClientSelect = this.handleClientSelect.bind(this);    
    this.openRunModal = this.openRunModal.bind(this);
    this.getClientDetail = this.getClientDetail.bind(this);
    //this.handleSetUrgent = this.handleSetUrgent.bind(this);
    this.loadLocation = this.loadLocation.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
    this.handleSetDeliveryDaysChange = this.handleSetDeliveryDaysChange.bind(this);
    this.getRunColumns = this.getRunColumns.bind(this);
  }
  
  
  

  handleSetDeliveryDaysChange(val) {
    
    let {location} = this.state;
    let {setDeliveryDays} = location;

    let values = IsNullOrUndefined(val) || isNullEmptyOrWhitespace(val) ? [] : val.split(',').map(x => parseInt(x));
    
    this.setState({
      location: {
        ...location, setDeliveryDays: values.map(x => {
          let existing = setDeliveryDays.find(y => y.dayOfWeek === x);
          return IsNullOrUndefined(existing) ? {
            dayOfWeek: x,
          } : existing;
        })
      }
    });
  }
  
  handleLocationFieldChange(e) {
    let x = {...this.state.location};
    if(e.target.name === 'setupComplete') {
      x['completedBy'] = e.target.checked ? this.props.account.user.id : null;
      x[`${e.target.name}`] = e.target.checked;
    } else if(e.target.type === "checkbox"){
      if(e.target.name === 'isRebate'){
        x.isRebate = this.accountDetailsValidatedForRebate(x, e.target.checked) ? e.target.checked : false;
      }
      else{
        x[`${e.target.name}`] = e.target.checked;
      }
    } else if (e.target.name === 'assignedCustomerTypes'){
      x[`${e.target.name}`] = e.target.value.map(x => x.value);
    } 
    else {
      x[`${e.target.name}`] = e.target.value;
    }

    if(e.target.name === 'isTinLocation' && e.target.checked){
      x['isSmsAccepted'] = true;
    }

    if(e.target.name === 'estimatedFreshOilLitresPerDay') {
      x['estimatedFreshOilLitresPerDay'] = Number.parseInt(e.target.value || "0"); 
    }

    // If Location is rebate recipient, assign default value for myob company name
    if(e.target.name === "isRebateRecipient" && e.target.checked && !x.myobCompanyName){
      x['myobCompanyName'] = `${x.clientCompanyName} - ${x.locationName}`;
    }
    this.setState({location: x});
  }

  accountDetailsValidatedForRebate = (location,rebateEnabled) => {
    if(trimWhiteSpaces(location.accountBsb) && trimWhiteSpaces(location.accountName) && trimWhiteSpaces(location.accountNumber)){
      return true;
    }
    if(rebateEnabled){
      toastr.error("Account Name, Bsb and Account Number are required to enable rebate.");
    }
    return false;
  }

  handleSaveLocation(){
    if(this.props.locations.saveInfo.saving || this.state.checkingUniqueness){
      return;
    }
    let {valid} = this.validateLocation();
    if(!valid){
      return;
    }

    const {location, originalLocation} = this.state;
    const trimmedName = trimWhiteSpaces(location.locationName);
    const originalName = originalLocation ? trimWhiteSpaces(originalLocation.locationName || '') : '';
    const nameChanged = trimmedName !== originalName;

    const performSave = () => {
      this.setState({saving: true});
      this.props.dispatch(saveLocation({
        ...location,
        locationName: trimmedName,
      }));
    };

    if (nameChanged) {
      this.setState({checkingUniqueness: true});
      apiRequest(`/api/locations/exact?name=${encodeURIComponent(trimmedName)}`)
        .then(x => {
          this.setState({checkingUniqueness: false});
          if (x && x.data && x.data.exists) {
            toastr.error('A location with this name already exists. Please choose a different name.');
          } else {
            performSave();
          }
        });
    } else {
      performSave();
    }
  }

  loadCustomerTypes() {
    apiRequest("/api/locations/lookups/customer-types").then(x=>{
      const customerTypes = mustBeArray(x.data).map(c => ({
        value: c.id,
        label: `${c.type} - ${c.name}` 
       }));
      this.setState({customerTypes});
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (!prevProps.locations.saveInfo.saved && this.props.locations.saveInfo.saved && this.props.locations.saveError.location === undefined) {
      if (this.props.locations.saveInfo.isNew) {
        this.props.navigate(`${BASE_URL}/manage/locations/${this.props.locations.saveInfo.location.id}`, {replace: true});
      } else if (this.props.onComplete) {
        this.props.onComplete(true);
      } else {
        this.props.navigate(-1);
      }
    }

    if (prevProps.locationId !== this.props.locationId) {
      this.loadLocation();
    }
  }

  componentDidMount() {
    this.loadCustomerTypes();
    if(this.props.router) {
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    }    
    if (this.props.locationId === -1) {
      this.setState({
        location: NewLocation(),
        isNewLocation: true,
        selectedClient: null
      }, this.fetchClients);
    } else {
      this.loadLocation();
    }
  }

  routerWillLeave(nextLocation) {
    // // return false to prevent a transition w/o prompting the user,
    // // or return a string to allow the user to decide:
    // // return `null` or nothing to let other hooks to be executed
    // //
    // // NOTE: if you return true, other hooks will not be executed!
    // if (!this.state.isSaved)
    // return 'Your work is not saved! Are you sure you want to leave?';
    if (!this.state.saving && JSON.stringify(this.state.location) !== JSON.stringify(this.state.originalLocation)) {
      return 'Are you sure you want to leave without saving your changes?';
    }

    return;
  }

  getLocationUsage(){
    apiRequest(
      `/api/locations/locationusage?locationIds=${this.props.locationId}`
    ).then((x) => {
      this.setState({
        locationUsage:  x.data,
      });
    });
  }

  loadLocation(){
    this.setState({saving: false});
    const {locationId} = this.props;   
    
    apiRequest(`/api/managelocations/${locationId}`)
      .then(x => {
        if (x && x.error) {
          let message = `You don't yet have access to this locaion, please wait until any authorisation requests are approved`;
          toastr.warning(message);
        } else if (x.data.length == 0) {
          let message = `You don't yet have access to this location, please wait until any authorisation requests are approved`;
          toastr.warning(message);
          this.setState({message, location: null, originalLocation: null});
        } else {
          this.setState({
            message: '',
            originalLocation: x.data,
            location: x.data,
            selectedClient: {
              id: x.data.clientId,
              companyName: x.data.clientCompanyName,
            }
          }, async () => {            
            apiRequest(`/api/managelocations/runhistory/${locationId}`)
              .then(x => {
                this.setState({
                  runs: Array.from(x.data),
                });
              });
          });
        }
      });
      
    this.getLocationUsage();
  }

  handleUnlinkMyob = () => {
    const {location} = this.state;
    this.props.dispatch(unLinkMyob({id: location && location.id, isClient: false})).then(resp => {
      if(!requestHasError({x: resp})){
        toastr.success("Unlinked supplier in MYOB");
        this.setState({location: {...this.state.location, myobID: null}, originalLocation: {...this.state.originalLocation, myobID: null}});
      }
    });
  };

  validateLocation(){
    let {location} = this.state;
    if(location){
      if(location.isRebate && !(trimWhiteSpaces(location.accountNumber) && trimWhiteSpaces(location.accountName) && trimWhiteSpaces(location.accountBsb))){
        return {valid: false, error: 'Account Name, Bsb and Account Number are required to enable rebate.'};
      }
      if(trimWhiteSpaces(location.locationName)==='') {
        return {valid: false, error: 'Location name must be provided'};
      } else if(location.estimatedLitresPerDay != '' && isNaN(parseFloat(location.estimatedLitresPerDay))){
        return {valid: false, error: 'Estimated litres per day must be numeric'};
      }

      // Validate length of myob company name max 50 characters
      if(location.isRebateRecipient && !trimWhiteSpaces(location.myobCompanyName)){
        return {valid: false, error: 'MYOB Company Name must be provided'};
      }
      if(location.isRebateRecipient && location.myobCompanyName.length > 50){
        return {valid: false, error: 'MYOB Company Name must less than 50 characters'};
      }

      // Max allowed location name length is 50 characters
      if(trimWhiteSpaces(location.locationName).length > 50){
        return {valid: false, error: 'Location name must less than 50 characters'};
      }

      if(location.accountBsb && location.accountBsb.trim() != '' && !location.accountBsb.match(/^\d{3}\-\d{3}$/g)){
        return {valid: false, error: 'BSB must be in format ###-###'};
      }
      if(location.accountName && location.accountName.trim()!='' || location.accountBsb && location.accountBsb.trim()!='' || location.accountNumber && location.accountNumber.trim()!='') {
        if (!location.accountName || location.accountName.trim() == '' || !location.accountBsb || location.accountBsb.trim() == '' || !location.accountNumber || location.accountNumber.trim() == '') {
          return {valid: false, error: 'Please complete financial details'};
        }
        if(!isValidAccountName(location.accountName)){
          return {valid: false, error: 'Account name is invalid. '};
        }
      }
      // Validate accounter number - cannot be more than 9 characters
      if(trimWhiteSpaces(location.accountNumber).length > 9){
        return {valid: false, error: 'Account Number must be less than 9 characters.'};
      }
      // ABN is required if isRebate is selected
      if(location.isRebate && !trimWhiteSpaces(location.abn)){
        return {valid: false, error: 'ABN must be provided'};
      }
      // Validate ABN to specific format
      if(!isValidAbn(location.abn)){
        return {valid: false, error: 'ABN must be in format ## ### ### ###'};
      }
      if(this.refs.addresses && this.refs.communications) {
        let addresses = this.refs.addresses.getCurrentState();
        let communications = this.refs.communications.getCurrentState();
        if (addresses == null || communications == null) {
          return {valid: false, error: 'Must complete address or communication details'};
        }
      }

      if(!location.addresses[0] || ((location.addresses[0] && location.addresses[0].latitude == null) || (location.addresses[0] && location.addresses[0].latitude == null))){
        return {valid: false, error: 'Must complete address or communication details'};
      }

      if(location.locationStatusUniqueCode == null){
        return {valid: false, error: 'Location status is required'};
      }

      if(location.locationTypeUniqueCode == null){
        return {valid: false, error: 'Location type is required'};
      }

      if(location.assignedCustomerTypes === null || location.assignedCustomerTypes.length === 0){
        return {valid: false, error: 'Please assign at least one customer type'};
      }
    }
    return {valid: true, error: ''};
  }

  fetchClients(input) {
    input = input || '';
    let url = (this.props.clientId) ? `/api/clients?clientId=${this.props.clientId}` : input.trim() == '' && this.state.location.clientId > 0 ? `/api/clients?clientId=${this.state.location.clientId}` : `/api/clients?name=${encodeURI(input)}`;
    return apiRequest(url)
      .then(x => {

        if(this.props.clientId && x.data && x.data.length === 1) {
          this.setState({
            selectedClient: {id: this.props.clientId, companyName: x.data[0].companyName},
            location: {
              ...this.state.location,
              clientId: this.props.clientId,
              clientCompanyName: x.data[0].companyName,
            }
          });
        }

        return {
          options: x.data,
        };
      });
  }

  getClientDetail(ev, type) {
    ev.preventDefault();
    let url = `/api/clients?clientId=${this.state.location.clientId}`;
    return apiRequest(url)
      .then(x => {
        let client = x.data[0];
        let clientAddress = client.addresses.length >= 1 ? client.addresses[0] : null;
        if (type == 'finance') {
          this.setState({
            location: {
              ...this.state.location,
              accountName: client.accountName,
              accountBsb: client.accountBsb,
              accountNumber: client.accountNumber,
            }
          });
        }
        if (type == 'address' && clientAddress) {
          clientAddress.addressType = 'Location';
          clientAddress.id = -1;
          clientAddress.isPrimary = true;
          this.setState({
            location: {
              ...this.state.location,
              addresses: [clientAddress]
            }
          });
        }
      });
  }

  handleClientSelect(val){
    if(val == null){
      this.setState({location: {...this.state.location, clientId: null}, selectedClient: null});
    }else {
      let location = {...this.state.location, clientId: val.id, clientCompanyName: val.companyName};
      this.setState({location, selectedClient: val});
    }
  }  

  openRunModal(e, runId, locationId, showLocationsWithNotes){
    e.preventDefault();
    this.setState({ showLocationsWithNotes }, () => {
      this.setState({viewRunId: runId, viewLocationId: locationId});
    });
   
  }
  
  getRunColumns() {    
    let {isSuperUser,account } = this.props;
    let {location} =  this.state;
    const isAdmin = allowUserWithRoles(account, [ROLE_Admin, ROLE_SuperUser, ROLE_OfficeUser]);

    return [
      {
        id: 'timeStart',
        accessor: c => (isAdmin ? <a href="" onClick={(e) => this.openRunModal(e, c.id, location.id)}>
              {getRunFlag(c.truckCollectionTypeCode)} - {moment(c.timeStart).format('YYYY-MM-DD')} - #{c.id}</a>
            : `#${c.id}`),
        Header: 'Run Date',
      },
      {
        id: 'datePickedUp',
        accessor: c => (c.datePickedUp ? moment(c.datePickedUp).format('DD/MM/YYYY LT') : ''),
        Header: 'Picked Up',
        sortMethod: (a, b) => {
          return moment(a, 'DD/MM/YYYY LT').isAfter(moment(b, 'DD/MM/YYYY LT')) ? 1 : -1;
        },
      },
      {
        accessor: 'driverUserName',       
        Header: 'Driver',
        width: 150,
      },
      {
        id: "note",
        accessor: c => (<a href="" onClick={(e) => this.openRunModal(e, c.id, location.id, true)}>Driver notes</a>),      
        Header: 'Note',
        width: 120,
      },
      {
        accessor: 'pickupStatus',
        Header: 'Status',
        width: 100,
      },
      {
        id: 'calculatedLitres',
        accessor: c => (isAdmin ? Math.round(c.calculatedLitres) : c.calculatedLitres > 0 ?
            Math.round(location.collectionWasteFactor > 0 ? (1-(location.collectionWasteFactor/100)) * c.calculatedLitres : c.calculatedLitres) : 'NA'),
        Header: 'Estimated',
        width: 100,
      },
      {
        id: 'estimatedLitresPickedUp',
        accessor: c => (isAdmin ? c.estimatedLitresPickedUp.toFixed(2): c.estimatedLitresPickedUp > 0 ?
            Math.round(location.collectionWasteFactor > 0 ? (1-(location.collectionWasteFactor/100)) * c.estimatedLitresPickedUp.toFixed(2) : c.estimatedLitresPickedUp.toFixed(2)) : 'NA'),
        Header: 'Actual',
        width: 100,
      }
    ];
  }

  isBulkCustomerType() {
    return GetIsBulkCustomerType(this.state.location.assignedCustomerTypes);
  }

  checkIsCollectionCustomer(){
    return GetIsCollectionCustomer(this.state.location.assignedCustomerTypes);
  }

  checkIsFreshOilCustomer(){
    return GetIsFreshOilCustomer(this.state.location.assignedCustomerTypes);    
  }

  render(){
    let {location, runs, showLocationsWithNotes, customerTypes} =  this.state;
    let {isLocationUser, isClientUser, isSuperUser, showIsUrgent, account} = this.props;
    let locationValid = this.validateLocation();
    const isAdmin = allowUserWithRoles(account, [ROLE_Admin, ROLE_SuperUser, ROLE_OfficeUser]);    
    
    return (<div>
      <RunModal runId={this.state.viewRunId}
                onClosing={()=> this.setState({viewRunId: 0, viewLocationId: 0, showLocationsWithNotes: false})}
                locationId={this.state.viewLocationId}
                dispatch={this.props.dispatch}
                account={this.props.account}
                showPickupImages={false}
                showLocationsWithNotes={showLocationsWithNotes}
      />
      {location ? <div className="container">

        {/* <Prompt
          when={location.locationName===''}
          message={location => `Are you sure you want to go to ${location.pathname}`}

        />*/}

        <div className="row">
          <div className="col-12">

            <h5><a href="#"
                   className="text-muted"
                   onClick={(e)=> {
                     e.preventDefault();
                     if (JSON.stringify(this.state.location) === JSON.stringify(this.state.originalLocation) ||
                       confirm('Are you sure you want to leave without saving your changes?')) {
                       this.props.onComplete ? this.props.onComplete(false) : this.props.navigate(-1);
                     }
                   }}>back...</a></h5>
            {this.state.locationUsage.length > 0 ? this.state.locationUsage.map((x,i) => <LocationUsage key={`${x.id}-${i}`} location={x} />) : null}


            {showIsUrgent &&
                <Aux>
                  <div className="form-group row" style={{marginLeft: '0px'}}>
                  { location.isUrgentDelivery ?
                     <Badge className={`py-q px-q mr-2`} color={"danger"}>
                      Requested Urgent Delivery
                    </Badge> : 
                    <Badge className={`py-q px-q mr-2`} color={"success"}>
                        No Requests for Urgent Delivery
                    </Badge>
                  }
                    { location.isUrgentCollection ?
                        <Badge className={`py-q px-q`} color={"danger"}>
                          Requested Urgent Collection
                        </Badge> :
                        <Badge className={`py-q px-q`} color={"success"}>
                          No Requests for Urgent Collection
                        </Badge>
                    }
                </div>
                  { location.locationStatusUniqueCode === "A" &&
                      <ClientHomeActionButtons locationId={location.id} assignedCustomerTypes={location.assignedCustomerTypes} />
                  }
              </Aux>
            }


            <div className="form-horizontal">
              {/*<div className="form-group row">
                <h4>{location.locationName}&nbsp;&nbsp;<a href="#"
                                                                  className="text-muted"
                                                                  onClick={(e)=> {e.preventDefault(); this.props.onComplete(false);}}>cancel...</a></h4>
              </div>*/}


              { isAdmin && <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="clientId">{
                    location.clientId == null ?
                      <span>Client</span> :
                      <Link to={`${BASE_URL}/manage/clients/${location.clientId}`} target="_blank">Client</Link>
                }</label>
                <div className="col-md-8">
                  <Select.Async
                    name="clientId"
                    multi={false}
                    simpleValue={false}
                    loadOptions={this.fetchClients}
                    clearable={true}
                    valueKey={'id'}
                    labelKey={'companyName'}
                    onChange={this.handleClientSelect}
                    value={this.state.selectedClient}
                    placeholder="Select client"
                    searchable={true}
                    autoload={true}
                  />
                </div>
              </div> }

              { isAdmin && <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="locationStatusUniqueCode">Status</label>
                <div className="col-md-8">
                  <Select
                    name="locationStatusUniqueCode"
                    value={location.locationStatusUniqueCode}
                    multi={false}
                    clearable={false}
                    simpleValue={true}
                    options={this.state.locationStatuses}
                    onChange={(val) => this.setState({location: {...this.state.location, locationStatusUniqueCode: val}})}
                  />
                </div>
              </div> }

              { isAdmin && 
              <Aux>
                <div className="form-group row">
                  <label className="col-md-2 form-control-label"  htmlFor="locationTypeUniqueCode">Location Type</label>
                  <div className="col-md-8">
                    <Select
                        name="locationTypeUniqueCode"
                        value={location.locationTypeUniqueCode}
                        multi={false}
                        clearable={false}
                        simpleValue={true}
                        options={this.state.locationTypes}
                        onChange={(val) => this.setState({location: {...this.state.location, locationTypeUniqueCode: val}})}
                    />
                  </div>
                </div>
                {location.locationTypeUniqueCode === LOCATION_TYPE_BASE_CODE && <TextBoxControl
                    name={'qrPrefix'}
                    value={location.qrPrefix}
                    onChange={this.handleLocationFieldChange}
                    labelText={'QR Prefix'}                    
                /> }
                <AttachmentView visible={location.locationTypeUniqueCode === LOCATION_TYPE_BASE_CODE}
                                attachment={location.qrAttachment}
                                onChange={(attachment) => this.setState({location: {...location, qrAttachment: attachment === null ? null : {...attachment}}})} />
              </Aux>}

              <TextBoxControl
                name={'locationName'}
                value={location.locationName}
                onChange={this.handleLocationFieldChange}
                labelText={'Location Name'}
                disabled={isLocationUser}
              />

              <div className="form-group row">
                <div className="col-8 offset-2">
                  <ExistingClientLocaion name={location.locationName} mode={'location'} />
                </div>
              </div>

              

              <TextBoxControl
                name={'buildingName'}
                value={location.buildingName}
                onChange={this.handleLocationFieldChange}
                labelText={'Building Name'}
                disabled={isLocationUser}
              />

              <TextBoxControl
                name={'estimatedLitresPerDay'}
                value={location.estimatedLitresPerDay}
                onChange={this.handleLocationFieldChange}
                labelText={'Waste Est. Litres Per Day'}
                type={'number'}
                visible={isAdmin && this.checkIsCollectionCustomer()}
              />

              <TextBoxControl
                name={'collectionWasteFactor'}
                value={isNaN(location.collectionWasteFactor) ? '' : location.collectionWasteFactor}
                onChange={(e)=>{
                  let val = parseInt(e.target.value);                  
                  this.setState({location: {...this.state.location, collectionWasteFactor: val}});
                }}
                labelText={'Collection Waste % (default 10%)'}
                type={'number'}
                visible={isAdmin && this.checkIsCollectionCustomer()}
              />

              <TextBoxControl
                name={'estimatedFreshOilLitresPerDay'}
                value={location.estimatedFreshOilLitresPerDay || 0}
                onChange={this.handleLocationFieldChange}
                labelText={'New Oil Est. Litres Per Day'}
                type={'number'}
                visible={isAdmin && this.checkIsFreshOilCustomer()}
              />

              { isAdmin && <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="locationTypeUniqueCode">Set Delivery Days</label>
                <div className="col-md-8">
                  <Select                      
                      name="locationTypeUniqueCode"
                      value={IsNullOrUndefined(location.setDeliveryDays) ? [] : location.setDeliveryDays.map(x => x.dayOfWeek)}
                      multi
                      simpleValue
                      clearable={true}                      
                      options={DaysOfWeek}
                      onChange={this.handleSetDeliveryDaysChange}
                  />
                </div>
              </div> }

              <CheckBoxControl
                name={'isSmsAccepted'}
                value={location.isSmsAccepted}
                onChange={this.handleLocationFieldChange}
                labelText={'Is SMS Accepted'}
              />

              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="assignedCustomerTypes">Customer Type</label>
                <div className="col-md-8">
                  <Select
                    name="assignedCustomerTypes"
                    value={location.assignedCustomerTypes || []}
                    multi
                    clearable={true}
                    options={customerTypes}
                    onChange={(v) => this.handleLocationFieldChange({target: {name: "assignedCustomerTypes", value: v}})}
                  />
                </div>
              </div>

              <CheckBoxControl
                  name={'isIscc'}
                  value={location.isIscc}
                  onChange={this.handleLocationFieldChange}
                  labelText={'Is ISCC compliant'}
              />

              {!isAdmin && <div className="form-group row">
                <label className="col-md-2 form-control-label" >Has Heater</label>
                <div className="col-md-6">
                  {location.hasHeater ? 'yes' : 'no'}
                </div>
              </div> }

              {isAdmin && <div className="form-group row">
                <label className="col-md-2 form-control-label">Is Urgent Delivery</label>
                <div className="col-md-6">
                  {location.isUrgentDelivery ? 'yes' : 'no'}
                </div>
              </div> }
              {isAdmin && <div className="form-group row">
                <label className="col-md-2 form-control-label">Is Urgent Collection</label>
                <div className="col-md-6">
                  {location.isUrgentCollection ? 'yes' : 'no'}
                </div>
              </div> }

              <CheckBoxControl
                  name={'payingClient'}
                  value={location.payingClient}
                  onChange={this.handleLocationFieldChange}
                  labelText={'Paying Client'}
              />

              <CheckBoxControl
                    name={'isRebate'}
                    value={location.isRebate}
                    onChange={this.handleLocationFieldChange}
                    labelText={'Is Rebate'}
                />

              <CheckBoxControl
                    name={'isCollectionOnHold'}
                    value={location.isCollectionOnHold}
                    onChange={this.handleLocationFieldChange}
                    labelText={'On Hold — Collection'}
                />

              <CheckBoxControl
                    name={'isDeliveryOnHold'}
                    value={location.isDeliveryOnHold}
                    onChange={this.handleLocationFieldChange}
                    labelText={'On Hold — Delivery'}
                />
              <div className={location && location.myobID ? '' : "mb-2"}>
                <TextBoxControl
                  name={'abn'}
                  value={location.abn == null ? '' : location.abn}
                  onChange={this.handleLocationFieldChange}
                  labelText={'ABN'}
                  disabled={isLocationUser}
                  fieldType="abn"
                />
              </div>

              {
                location && location.myobID && <Button color="success" className="mt-1 mb-1" onClick={this.handleUnlinkMyob}>Unlink Supplier in MYOB</Button>
              }

              { isAdmin && <div>
                  <h6>Account Information {location.clientId && <a href="#" onClick={(e)=> this.getClientDetail(e, 'finance')}>Copy from client</a>}</h6>
                  <TextBoxControl
                    name={'accountName'}
                    value={location.accountName}
                    onChange={this.handleLocationFieldChange}
                    labelText={'Account Name'}
                  />
                  <TextBoxControl
                    name={'accountBsb'}
                    value={location.accountBsb}
                    onChange={this.handleLocationFieldChange}
                    labelText={'Account BSB'}
                  />
                  <TextBoxControl
                    name={'accountNumber'}
                    value={location.accountNumber}
                    onChange={this.handleLocationFieldChange}
                    labelText={'Account Number'}
                  />
                   <CheckBoxControl
                        name={'isRebateRecipient'}
                        value={location.isRebateRecipient}
                        onChange={this.handleLocationFieldChange}
                        labelText={'Rebate Payment to Location'}
                    />
                   {
                    location && location.isRebateRecipient &&
                    <TextBoxControl
                      name={'myobCompanyName'}
                      value={location.myobCompanyName}
                      onChange={this.handleLocationFieldChange}
                      labelText={'MYOB Company Name'}
                    />
                   }

                  {location.dateCreated && <div className="form-group row">
                    <label className="col-2 form-control-label">Date Created</label>
                    <div className="col-8">
                      {moment(location.dateCreated).format('DD/MM/YYYY LT')}
                    </div>
                  </div>}

                  {location.dateModified && <div className="form-group row">
                    <label className="col-2 form-control-label">Date Modified</label>
                    <div className="col-8">
                      {moment(location.dateModified).format('DD/MM/YYYY LT')}
                    </div>
                  </div>}
              </div> }

              {location.id > 0 && <ClosedPeriodsView locationId={location.id} /> }

              { this.isBulkCustomerType() && <LocationTanksView locationId={location.id} isAdmin={isAdmin} /> }

              <div className={"row"} style={{marginBottom: '20px'}}><div className={"col-12"}>&nbsp;</div></div>
              
              {(location.clientId && isAdmin) && <a href="#" onClick={(e)=> this.getClientDetail(e, 'address')}>Copy address from client</a>}
                {this.state.location.addresses && <AddressesView
                addresses={location.addresses}
                ref="addresses"
                onChange={(addresses)=> this.setState({location: {...this.state.location, addresses}})}
                enableDelete={false}
                enableAdd={(this.state.location.addresses.length == 0)}
                enableAddressType={(this.state.location.addresses.length == 0)}
                enableIsPrimary={(this.state.location.addresses.length == 0)}
              /> }

              <CommunicationsView
                communications={location.communications}
                ref="communications"
                onChange={(communications)=> this.setState({location: {...this.state.location, communications}})}
              />

              <TextAreaControl
                name={'driverNotes'}
                value={location.driverNotes}
                onChange={this.handleLocationFieldChange}
                labelText={'UCO Driver Notes'}
                visible={isAdmin}
              />

              <TextAreaControl
                name={'nextPickupNote'}
                value={location.nextPickupNote}
                onChange={this.handleLocationFieldChange}
                labelText={'UCO Next Pickup Note'}
                visible={isAdmin}
              />

              <TextAreaControl
                name={'driverDeliveryNotes'}
                value={location.driverDeliveryNotes}
                onChange={this.handleLocationFieldChange}
                labelText={'Fresh Oil Driver Notes'}
                visible={isAdmin}
              />

              <TextAreaControl
                name={'nextDeliveryPickupNote'}
                value={location.nextDeliveryPickupNote}
                onChange={this.handleLocationFieldChange}
                labelText={'Fresh Oil Next Delivery Notes'}
                visible={isAdmin}
              />

              <NotesView
                headerText={'Office Notes'}
                notes={location.officeNotes}
                onChange={(officeNotes)=> this.setState({location: {...this.state.location, officeNotes}})}
                visible={isAdmin}
                isLocationView={true}
                runNotes={location.runNotes}
              />

              <AttachmentsView
                headerText={'UCO Driver Attachments'}
                attachments={location.attachments}
                onChange={(attachments)=> this.setState({location: {...this.state.location, attachments}})}
              />

              <AttachmentsView
                headerText={'Office Attachments'}
                attachments={location.officeAttachments}
                onChange={(officeAttachments)=> this.setState({location: {...this.state.location, officeAttachments}})}
                visible={isAdmin}
              />

              <AttachmentsView
                headerText={'Fresh Oil Driver Attachments'}
                attachments={location.deliveryAttachments}
                onChange={(deliveryAttachments)=> this.setState({location: {...this.state.location, deliveryAttachments}})}
                visible={isAdmin}
              />

              { location.id > 0 ? (<ContactsView parentEntityName={'locations'} parentEntityId={location.id} isAdmin={this.props.isAdmin} />)
                : (<h5 style={{marginBottom: '30px'}}>Please save the location to add location contacts</h5>)}

              { location.id > 0 ? (<UsersByClientLocationControl
                  mode={'location'}
                  locationId={location.id}
                  onSelectUser={x => window.open(x, '_blank')}
                />)
                : (<h5 style={{marginBottom: '30px'}}>Please save the location to view location users</h5>)}

              { (location.id > 0 && !isLocationUser) ? (<ContractsView
                  clientId={location.clientId}
                  location={location}
                  label={'Client Contracts'}
                  parentEntityId={location.id}
                  parentEntityName={'locations'}
                  isReadOnly={isClientUser}
                />)
                : (<h5 style={{marginBottom: '30px'}}>Please save the location to add client contracts</h5>)}

              {(!this.props.locations.saveInfo.saving && this.props.locations.saveError.location) &&
              <span className="text-danger" style={{marginRight: '10px'}}>{this.props.locations.saveError.error}</span>}

              {this.props.locations.saveInfo.saving ?
                <div className="form-group row">
                  <div className="col-12">
                    Saving... <i className="fa fa-cog fa-spin" />
                  </div>
                </div>
                :
                <div className="form-group row">
                  <div className="col-12">
                    {locationValid.valid && !isLocationUser ?
                      <Button color="primary" onClick={this.handleSaveLocation} style={{marginRight: '10px'}} disabled={this.props.locations.saveInfo.saving || this.state.checkingUniqueness}><i
                        className="fa fa-save"/>&nbsp;Save
                        Location</Button> :
                      <span className="text-danger" style={{marginRight: '10px'}}>{locationValid.error}</span>
                    }
                    <Button color="secondary" onClick={()=> {
                      if (JSON.stringify(this.state.location) === JSON.stringify(this.state.originalLocation) ||
                        confirm('Are you sure you want to leave without saving your changes?')) {
                        this.props.onComplete ? this.props.onComplete(false) : this.props.navigate(-1);
                      }
                    }}><i
                      className="fa fa-mail-reply"/>&nbsp;Cancel</Button>
                  </div>
                </div>
              }

              <div className="form-group row">
                <div className="col-12">
                  &nbsp;
                </div>
              </div>

              <div className="form-group row">
                <div className="col-12">
                  <h6>Run History</h6>
                </div>
                <div className="col-12">
                  <ReactTable
                      sortable={true}
                      filterable={false}
                      showPagination={true}
                      data={runs}
                      columns={this.getRunColumns()}
                      minRows={3}
                      defaultPageSize={10}
                      defaultSorted={[{id: 'datePickedUp', desc: true}]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div> : <div>Loading location... {this.state.message}</div>}
    </div>);
  }
}

EditLocationView.propTypes = {
  locationId: PropTypes.number.isRequired,
  onComplete: PropTypes.func,
  account: PropTypes.object.isRequired,
  isLocationUser: PropTypes.bool.isRequired,
  isClientUser: PropTypes.bool.isRequired,
  isSuperUser: PropTypes.bool.isRequired,
  showIsUrgent: PropTypes.bool
};

EditLocationView.defaultProps = {
  showIsUrgent: true
};

function mapStateToProps(state, ownProps){
  let id = -1;
  if(ownProps.routeParams && ownProps.routeParams.id){
    id = parseInt(ownProps.routeParams.id);
  } else if(ownProps.locationId) {
    id = ownProps.locationId;
  }

  let clientId = ownProps.clientId;
  if(!clientId && ownProps.location && ownProps.location.search){
    const queryClientId = new URLSearchParams(ownProps.location.search).get('clientId');
    if(queryClientId){
      clientId = parseInt(queryClientId);
    }
  }

  let isLocationUser = false;
  let isClientUser = false;
  let isSuperUser = false;
  let {user} = state.account;

  if(user){
    isLocationUser = user.hasRole(ROLE_LocationUser);
    isClientUser = user.hasRole(ROLE_ClientUser);
    isSuperUser = user.hasRole(ROLE_SuperUser);

    if(user.hasRole(ROLE_SalesManager)) {
      isClientUser = true;
      isLocationUser = true;
    }
  }

  return {
    locationId: id,
    clientId,
    isLocationUser,
    isClientUser,
    isSuperUser,
    locations: state.locations,
    account: state.account
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditLocationView));
